import { signRequest } from "./signRequest";
import type { UploadFileParams } from "./types";

export const uploadFile = async ({ file, signBody }: UploadFileParams): Promise<string> => {

  const signData = await signRequest(signBody);

  const formData = new FormData();

  Object.entries(signData.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  formData.append("file", file);

  const response = await fetch(signData.url, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Upload failed");
  }

  return signData.fields.key;
};